import React, { Component } from 'react';
import { Localization } from '../localization/index';
import { PakleanImages } from '../images/index';
import { Colors } from '../colors/index';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

import Modal from 'react-modal'
import { ClipLoader } from 'react-spinners';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const mapApiToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImFiYTEwODNiMDVkMjVmOTFhZTM1ODRmNjg3YjU1OWE2YjZlNTI2ZDEzODk3Y2FkZmRhY2MyMDg5OTVlYzUyOWViMTY0YmY4YjNkM2YxYjY0In0.eyJhdWQiOiI1NDQzIiwianRpIjoiYWJhMTA4M2IwNWQyNWY5MWFlMzU4NGY2ODdiNTU5YTZiNmU1MjZkMTM4OTdjYWRmZGFjYzIwODk5NWVjNTI5ZWIxNjRiZjhiM2QzZjFiNjQiLCJpYXQiOjE1NjY5MTgxMzMsIm5iZiI6MTU2NjkxODEzMywiZXhwIjoxNTY5NjAwMTMzLCJzdWIiOiIiLCJzY29wZXMiOlsiYmFzaWMiXX0.i7_vrr6EexnuICYlmPBlaETEhj-kX6xJyB7_95WPxsgywLUy3arGzZ6V0FD2uKcghthWdiYc0EFpMqq_gZGjFRFjEa7nQNaDt_jteO5m1koFscw2eV_tvPJNOyBzzkD1JxcZ9HxaIWkWSw8p2I7rMxbFZphujlSHziYtWZ1lekI4QUqoDGUwef-0xKpS7hUVnn7EVjXn8zmX_sAyay73EoA36A65Vu_bMsGZYKlrm05RNVX2Zos3hjdloLJCH4dlmcK59dl7Zlbj0YS6QfRKxrLVlG4aFZEqoYD-8MoBrXIoya94ypbJLgWZQZYbH95rBeXCsZCl3gWSaTJyeO7GLQ"

class MapScreen extends Component {
  state = {
    latitude: 35.6911872,
    longitude: 51.4926528,
    error: null,
    zoom: [15],
    isLoading: true,
    value: null,
    log: null,
    movingOnMap: false,
    pinStyle: styles.markerStop,
    addr: '',
    minBasketSize: 0,
    logisticFee: 0,
    addressDetails: Localization.Farsi.AddressDetails,
    searchAddrResult: [],
    showSearchResult: false,
    searching: false,
    showAddressModal: false,
    saveAddress: false,
    addressUnit: "",
    addressNo: "",
    addressTopic: "",
    mapType: 'neworder',
    showAddreeNameSection: true,
    showAddresNameRequest: false,
    addressNameRequestHeight: 0,
    addressTopicButtonStyle: styles.confirmButtonModalInactive,
    addressDetailsModalHeight: 0,
    isMapLoaded: null,
    showAddressNotComplete: false,
    campaignModal: false,
    campaignItem: undefined,


    address: '',
    deliverAddress: '',
    customerName: '',
    customerPhone: '',
    fetchTime: '',
    deliverTime: '',
    orderId: '',
    shortId: '',
    order: null,
    region: undefined


  }

  _onChangeText(text) {
    this.setState({ isLoading: true, value: text });
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 5000)
  }

  centerMap() {
    this.map.panTo({ lat: this.state.latitude, lng: this.state.longitude })
  }



  decodeGeoLocation = () => {

    let me = this;

    fetch("https://map.ir/reverse/fast-reverse?lat=" + this.state.latitude + "&lon=" + this.state.longitude, {
      method: "GET",
      headers: {
        'x-api-key': mapApiToken
      },
    }).then(response => response.json()).then(async (responseJson) => {
      console.log(responseJson)
      me.setState({
        addr: responseJson.address_compact,
        region: this.splitRegionString(responseJson.region)
        //  minBasketSize: responseJson.minBasketSize,
        //   logisticFee: responseJson.cost 
      });
    });


    // fetch("https://client.api.paklean.com/geolocation/decode", {
    //   method: "POST",
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     lat: this.state.latitude,
    //     lng: this.state.longitude
    //   })
    // }).then(response => response.json()).then(async (responseJson) => {
    //   me.setState({ addr: responseJson.addr, minBasketSize: responseJson.minBasketSize, logisticFee: responseJson.cost });
    // });
  }

  searchAddress = () => {
    let text = this.state.addr;
    if (text.toString().trim() == '') {
      this.setState({ showSearchResult: false, searchAddrResult: [] });
    }
    else {
      this.setState({ searching: true })
      let me = this;
      fetch('https://map.ir/search/autocomplete', {
        method: 'POST',
        headers: {
          'x-api-key': mapApiToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          text: this.state.addr,
          location: {
            type: "Point",
            coordinates: [51.389301, 35.690770]
          },
          $filter: "province eq تهران"
        }),

      }).then(response => response.json())
        .then((responseJson) => {

          console.log(responseJson)

          me.setState({ searching: false, showSearchResult: true, searchAddrResult: responseJson.value });
        }).catch((err) => {
          //TODO : address fetched error
          me.setState({ searching: false, showSearchResult: false, searchAddrResult: [] });
        })
    }
  }


  handleMapReady = (mapProps, map) => {

    this.map = map
    this.setState({ isLoading: false })

    map.addListener('idle', () => {
      console.log({ lng: map.center.lng(), lat: map.center.lat() });
      this.setState({ movingOnMap: false, longitude: map.center.lng(), latitude: map.center.lat() }, () => {
        this.decodeGeoLocation();
      });

    });

    map.addListener('drag', () => {
      this.addressInput.blur()
      this.setState({ searchAddrResult: [] })

    });
    map.addListener('click', () => {
      this.addressInput.blur()
      this.setState({ searchAddrResult: [] })

    });

  };


  splitTimeStrings = (string) => {
    let array = string.split(" ")

    let date = array[0]

    let hour = array[1].split(":")[0]

    return date + " ساعت " + hour
  }

  splitRegionString = (string) => {
    let array = string.split(" ")
    let region = array[1]
    return parseInt(region)
  }


  getOrderId = (e) => {

    e.preventDefault()
    this.setState({ isLoading: true })

    fetch('https://pnl.api.paklean.com/puser/orders/byShortCode/' + this.state.shortId.toUpperCase(), {
      method: 'GET',
      headers: {
        Authorization: global.authorization,
        'Content-Type': 'application/json'
      },

    }).then(response => response.json())
      .then((responseJson) => {
        if (responseJson.order) {
          this.setState({
            isLoading: false,
            order: responseJson.order,
            orderId: responseJson.order._id,
            address: responseJson.order.address,
            deliverAddress: responseJson.order.deliverAddress,
            customerName: responseJson.order.userId.name,
            customerPhone: responseJson.order.userId.username,
            deliverTime: this.splitTimeStrings(responseJson.order.persianDeliverDate),
            fetchTime: this.splitTimeStrings(responseJson.order.persianFetchDate),
            addr: responseJson.order.address,

          }, this.searchAddress);
          console.log(this.state.orderId)
        } else {
          this.setState({ isLoading: false, shortId: '' }, () => {
            toast(Localization.Farsi.shortIdError)
          });
        }
      }).catch((err) => {
        //TODO : address fetched error
        this.setState({ isLoading: false, });
      })


  }




  editFetchAddressGeo = () => {
    this.setState({ isLoading: true })

    if (this.state.shortId === '' || this.state.shortId === null) {
      this.setState({ isLoading: false })
      toast(Localization.Farsi.pleaseEnterShortId)
    } else {

      fetch('https://pnl.api.paklean.com/puser/order', {
        method: 'PUT',
        headers: {
          Authorization: global.authorization,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          fetchLng: this.state.longitude,
          fetchLat: this.state.latitude,
          fetchRegion: this.state.region,
          orderId: this.state.orderId
        }),

      }).then(response => response.json())
        .then((responseJson) => {
          this.setState({ isLoading: false, });

          if (responseJson.code === 200) {
            toast(Localization.Farsi.addressChangedSuccessfully)
          } else {
            toast(Localization.Farsi.error)
          }

        }).catch((err) => {
          //TODO : address fetched error
          this.setState({ isLoading: false, });
          toast(Localization.Farsi.error)

        })
    }

  }



  editDeliverAddressGeo = () => {
    this.setState({ isLoading: true })

    if (this.state.shortId === '' || this.state.shortId === null) {
      this.setState({ isLoading: false })

      toast(Localization.Farsi.pleaseEnterShortId)
    } else {

      fetch('https://pnl.api.paklean.com/puser/order', {
        method: 'PUT',
        headers: {
          Authorization: global.authorization,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          deliveryLng: this.state.longitude,
          deliveryLat: this.state.latitude,
          deliverRegion: this.state.region,
          orderId: this.state.orderId
        }),

      }).then(response => response.json())
        .then((responseJson) => {
          this.setState({ isLoading: false, });

          if (responseJson.code === 200) {
            toast(Localization.Farsi.addressChangedSuccessfully)
          } else {
            toast(Localization.Farsi.error)
          }

        }).catch((err) => {
          //TODO : address fetched error
          this.setState({ isLoading: false, });
          toast(Localization.Farsi.error)
        })
    }
  }


  onSearchAddressResult = (address) => {
    let coordinates = address.Coordinate
    this.setState({
      latitude: parseFloat(coordinates.lat), longitude: parseFloat(coordinates.lon),
      addr: address.Address, showSearchResult: false, searchAddrResult: []
    },
      this.centerMap
    );
    // this.decodeGeoLocation();
  }



  render() {
    return (

      <div style={styles.container}>
        <div style={styles.content}>



          <div style={styles.textInputContainer}>

            {/* <img style={{ padding: 7, cursor: 'pointer' }} src={PakleanImages.CurrentLocation} onClick={this.gotoCurrentLocation} /> */}

            <div style={{ display: "flex", flexDirection: 'column', width: '100%' }} >


              <div style={styles.orderBar} >
                <form style={styles.orderBarChilds}
                  // onClick={() => this.setState({ shortId: '' })}
                  onSubmit={this.getOrderId}>

                  <input
                    type="text"
                    style={styles.shortIdInput}
                    placeholder={Localization.Farsi.shortId}
                    value={this.state.shortId}
                    onChange={e => this.setState({ shortId: e.target.value })} />
                </form>

                <p style={styles.orderBarChilds} >{this.state.customerName}</p>
                <p style={styles.orderBarChilds} >{this.state.customerPhone}</p>
                <p style={styles.orderBarChilds} >دریافت: {this.state.fetchTime}</p>
                <p style={styles.orderBarChilds} >ارسال: {this.state.deliverTime}</p>

              </div>





              <div style={styles.addressBar}>
                <p style={{ width: '80%' }} >آدرس دریافت: {this.state.address}</p>
              </div>



              <div style={styles.addressBar}>
                <p style={{ width: '80%' }}>آدرس ارسال: {this.state.deliverAddress}</p>
              </div>





              <div style={{ height: 1, width: '100%', backgroundColor: 'black' }} />

              <form style={styles.textAddressForm}
                onSubmit={(e) => {
                  e.preventDefault()
                  this.searchAddress()
                }}>

                <input
                  type="text"
                  ref={addressInput => this.addressInput = addressInput}
                  style={styles.textAddressInput}
                  value={this.state.addr}
                  onChange={e => this.setState({ addr: e.target.value })} />
                <p>جستجوی آدرس: </p>

              </form>
            </div>
          </div>
          <div style={{ right: 0, top: 240, left: 0, paddingLeft: 10, paddingRight: 10, position: 'fixed', display: 'flex', alignItems: 'center', WebkitBoxAlign: 'center', WebkitBoxOrient: 'vertical', flexDirection: 'column', zIndex: 2 }}>
            {this.state.searchAddrResult ? this.state.searchAddrResult.map((address, index) => (
              index < 5 ?
                <button style={styles.searchResultRow} key={index} onClick={() => this.onSearchAddressResult(address)}>
                  {address.Address}
                </button>
                :
                null

            )


            )
              :
              null
            }
          </div>


          <Map
            google={this.props.google}
            style={{ width: '100%', height: '100%' }}
            initialCenter={{
              lat: this.state.latitude,
              lng: this.state.longitude
            }}
            zoom={15}
            zoomControl={false}
            mapTypeControl={false}
            streetViewControl={false}
            fullscreenControl={false}
            onReady={this.handleMapReady}
          />

          <img style={styles.markerStyle} src={PakleanImages.mapMove} />
        </div>





        <div style={styles.confirmButtonsContainer} >
          <button style={styles.confirmButton} onClick={() => {
            this.editFetchAddressGeo()
          }}>
            <p style={styles.buttonText}>
              {Localization.Farsi.confirmFetchAddress}
            </p>
          </button>


          <button style={styles.confirmButton} onClick={() => {
            this.editDeliverAddressGeo()
          }}>
            <p style={styles.buttonText}>
              {Localization.Farsi.confirmDeliverAddress}
            </p>
          </button>

        </div>

        <ToastContainer
          closeButton={false}
          hideProgressBar
          rtl
          style={{ textAlign: 'center', color: 'black', }}
          autoClose={2000}
          pauseOnFocusLoss={false}
          position="bottom-center" />


        <Modal
          isOpen={this.state.isLoading}
          style={styles.spinnerStyle} >
          <div style={{
            display: 'flex', justifyContent: 'center',
            WebkitBoxPack: 'center', WebkitBoxPack: 'center', WebkitBoxAlign: 'center', alignItems: 'center', WebkitBoxAlign: 'center',
          }}>
            <ClipLoader
              size={100}
              color={Colors.SpinnerColor}
              loading={this.state.isLoading}
            />
          </div>
        </Modal>


      </div >


    );
  }
}



export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCHGw0iRJC_-a6wlrGumFbTT0hrf80DemE"
})(MapScreen);

const styles = {

  modalStyles: {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: 0,
      transform: 'translate(-50%, -50%)'
    },
    overlay: {
      zIndex: 10,
    },
  },

  modalStylesNotComplete: {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: 0,
      transform: 'translate(-50%, -50%)'
    },
    overlay: {
      zIndex: 10,
      backgroundColor: "rgba(0, 0, 0, 0.85)",
    },
  }
  ,
  spinnerStyle: {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      border: 'none',
      outline: 'none',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'transparent'
    },
    overlay: {
      zIndex: 10,
    },
  },

  content: {

    position: 'fixed',
    // paddingTop: 50,
    width: '100%',
    height: '100%',
    display: 'flex',
    WebkitBoxOrient: 'vertical', flexDirection: 'column',
    alignItems: 'center', WebkitBoxAlign: 'center',
  },

  container: {
    // flex: 1,
    // display: 'flex',
    // alignItems: 'center', WebkitBoxAlign:'center',
    // justifyContent: 'center'

    display: '-webkit-box',
    display: '-moz-box',
    display: '-ms-flexbox',
    display: '-webkit-flex',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
    justifyContent: 'stretch',
    alignItems: 'flex-start',
    WebkitBoxOrient: 'vertical',
    WebkitBoxDirection: 'normal',
    WebkitFlexDirection: 'column',
    WebkitFlexGrow: 1,
    WebkitFlexShrink: 0,
    WebkitFlexBasis: 'auto',
    WebkitBoxPack: 'stretch',
    WebkitJustifyContent: 'stretch',
    WebkitBoxAlign: 'start',
    WebkitAlignItems: 'flex-start',
  },

  innerModalcontainer: {
    flex: 1,
    WebkitBoxOrient: 'vertical', flexDirection: 'column',
    padding: 10,
    display: 'flex',
    alignItems: 'center', WebkitBoxAlign: 'center',
    justifyContent: 'center'
  },
  mapPin: {
    zIndex: 2,
    width: 50,
    height: 50
  },

  markerStyle: {
    height: 100,
    width: 100,
    top: 'calc(50% - 97px)',
    left: 'calc(50vw - 50px)',
    position: 'absolute',
  },

  addrText: {
    color: "black",
    textAlign: 'center',
    flexWrap: 'wrap',
    fontSize: 12,
  },

  orderBar: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row-reverse',
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    alignItems: 'center', WebkitBoxAlign: 'center',
    height: 50,
    border: 'none',
    outline: 'none',
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    textAlign: 'right',
  },

  orderBarChilds: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    alignItems: 'center', WebkitBoxAlign: 'center',
    height: 50,
    padding: 5,
    fontSize: 14,
    border: 'none',
    outline: 'none',
    backgroundColor: "rgba(250, 250, 250, 1)",
    textAlign: 'center',
  },


  shortIdInput: {
    display: 'flex',
    width: '100%',
    fontSize: 14,
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    alignItems: 'center', WebkitBoxAlign: 'center',
    height: 50,
    border: 'none',
    direction:'ltr',
    outline: 'none',
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    textAlign: 'center',
  },

  textAddressForm: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    WebkitBoxPack: 'center',
    alignItems: 'center', WebkitBoxAlign: 'center',
    height: 40,
    fontSize: 16,
    border: 'none',
    outline: 'none',
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    textAlign: 'right',
  },



  textAddressInput: {
    height: 40,
    flex: 1,
    fontSize: 16,
    border: 'none',
    outline: 'none',
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    textAlign: 'right',
  },

  addressBar: {

    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 40,
    fontSize: 14,
    border: 'none',
    outline: 'none',
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    textAlign: 'right',

  },

  textInputContainer: {
    display: 'flex',
    backgroundColor: 'transparent',
    position: 'absolute',
    left: 5,
    right: 5,
    zIndex: 2,
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    alignItems: 'center', WebkitBoxAlign: 'center',
    borderWidth: 1,
    height: 180,
    borderRadius: 10,
    marginTop: 5,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "black",
  },
  textInputModal: {
    width: '100%',
    display: 'flex',
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    alignItems: 'center', WebkitBoxAlign: 'center',
    border: 'solid',
    borderWidth: 1,
    height: 50,
    borderRadius: 10,
    paddingLeft: 20,
    paddingRight: 20,
    // backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    textAlign: 'right'
  },
  addressDetailsInputs: {
    WebkitBoxOrient: 'vertical', flexDirection: 'column',

    WebkitBoxPack: 'start',
    justifyContent: 'flex-start',
    display: 'flex',
    alignItems: 'flex-end', WebkitBoxAlign: 'end',
    borderWidth: 1,
    marginTop: 30,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    paddingLeft: 20,
    paddingRight: 20,

    // backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    flex: 90,
    height: '100%'
  },

  confirmButtonsContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    bottom: 0,
    color: 'white',
    height: 50,
    zIndex: 2,
    width: "100%",
    backgroundColor: "#7178fc",
    justifyContent: "center",
    alignItems: 'center', WebkitBoxAlign: 'center',
    position: 'fixed'

  },

  confirmButton: {
    bottom: 0,
    color: 'white',
    height: 50,
    zIndex: 2,
    display: 'flex',
    border: 'solid',
    borderColor: 'white',
    borderWidth: 1,
    flex: 1, backgroundColor: "#7178fc",
    justifyContent: "center",
    alignItems: 'center', WebkitBoxAlign: 'center',
  },

  modalConfirmButton: {
    bottom: 0,
    color: 'white',
    height: 50,
    zIndex: 2,
    display: 'flex',
    width: "100%",
    backgroundColor: "#7178fc",
    justifyContent: "center",
    alignItems: 'center', WebkitBoxAlign: 'center',
    position: 'sticky'

  },
  buttonText: {
    color: 'white',
    fontSize: 16,
    textAlignVertical: 'center',
    textAlign: 'center',
    width: '100%',
  },
  addressDetailsView: {
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    flex: 99,
    height: 50,
    display: 'flex',
    justifyContent: "center",
    alignItems: 'center', WebkitBoxAlign: 'center',
    border: 'solid',
    borderWidth: 0.5,
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    marginLeft: 10,
  },
  addressDetailsEmptyText: {
    flex: 1,
    color: "black",
    textAlignVertical: 'center',
    textAlign: 'right',
    flexWrap: 'wrap',
    fontSize: 12,
  },
  addressDetailsContainer: {
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    display: 'flex',
    height: 50,
    width: '100%',
    justifyContent: "center",
    alignItems: 'center', WebkitBoxAlign: 'center',
  },
  addressDetailsContainerModal: {
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    display: 'flex',
    width: '100%',
    justifyContent: "flex-end",
    alignItems: 'flex-start', WebkitBoxAlign: 'start',
  },
  addressDetailsLeftBarModal: {
    height: '100%',
    backgroundColor: '#26D1B2',
    flex: 1,
    marginTop: 30,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
  },
  addressDetailsLeftBar: {
    height: 50,
    backgroundColor: '#26D1B2',
    flex: 1,
    marginRight: 10,
  },
  searchResultText: {
    color: "gray",
    textAlignVertical: 'center',
    textAlign: 'right',
    flexWrap: 'wrap',
    fontSize: 12,
    marginRight: 5
  },
  searchResultRow: {
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',

    WebkitBoxPack: 'end',
    justifyContent: 'flex-end',
    alignItems: 'center', WebkitBoxAlign: 'center',
    display: 'flex',
    color: 'gray',
    width: '95%',
    border: 'solid',
    backgroundColor: 'rgba(250, 250, 250, 1)',
    marginBottom: 5,
    borderWidth: 0.5,
    borderRadius: 10,
    paddingRight: 10,
    paddingLeft: 10,
    borderColor: 'gray',
    height: 50,
  },
  firstTimeLoadingIndicator: {
    position: 'absolute',
    alignItems: 'center', WebkitBoxAlign: 'center',
    display: 'flex',
    WebkitBoxOrient: 'vertical', flexDirection: 'column',
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    zIndex: 5,
    left: 0,
    right: 0,
    marginTop: 80
  },
  anyRequestTextBoxContainer: {
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    display: 'flex',

    WebkitBoxPack: 'end',
    justifyContent: 'flex-end',
    alignItems: 'center', WebkitBoxAlign: 'center',
    backgroundColor: Colors.White,
    width: '90%',
    height: 100,
    shadowColor: Colors.BackgroundColor,
    shadowOpacity: 0.5,
    shadowRadius: 2,
    shadowOffset: {
      height: 1,
      width: 0
    }
  },
  anyRequestTextBoxLeftt: {
    WebkitBoxOrient: 'vertical', flexDirection: 'column',
    display: 'flex',

    WebkitBoxPack: 'start',
    justifyContent: 'flex-start',
    alignItems: 'flex-end', WebkitBoxAlign: 'end',
    paddingRight: 5,
    height: 100,
    flex: 99
  },
  anyRequestTextBoxRight: {
    height: 100,
    backgroundColor: '#26D1B2',
    flex: 1,
  },
  topic: {
    fontSize: 12,
    color: Colors.Gray,
    marginRight: 10,
    marginTop: 10,
    marginBottom: 5
  },
  confirmButtonModalActive: {
    bottom: 0,
    height: 50,
    width: "100%",
    backgroundColor: Colors.ActiveButton,
    display: 'flex',
    justifyContent: "center",
    alignItems: 'center', WebkitBoxAlign: 'center',
    alignSelf: 'flex-end'
  },
  confirmButtonModalInactive: {
    bottom: 0,
    height: 50,
    width: "100%",
    backgroundColor: Colors.InactiveButton,
    justifyContent: "center",
    alignItems: 'center', WebkitBoxAlign: 'center',
    alignSelf: 'flex-end'
  },
  markerFixed: {
    display: 'flex',
    position: 'absolute',
    left: 0,
    right: 0,
    top: -70,
    bottom: 0,
    alignItems: 'center', WebkitBoxAlign: 'center',
    justifyContent: 'center',
    WebkitBoxPack: 'center',
  },
};

